export default __webpack_public_path__ + "static/media/english_test_mock.b44ebe85.png";